import i18next from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"

import common_ja from "./translations/ja/common.json"
import common_en from "./translations/en/common.json"
import common_vi from "./translations/vi/common.json"
import errors_ja from "./translations/ja/errors.json"
import errors_en from "./translations/en/errors.json"
import errors_vi from "./translations/vi/errors.json"

import { normalizeLang } from "./utils/normalizeLang"

const getInitialLanguage = () => {
  try {
    const persisted = normalizeLang(window?.localStorage?.getItem("lang"))
    if (persisted) return persisted
    // Default to Vietnamese to avoid mixed-language UI on first load.
    return "vi"
  } catch {
    return "vi"
  }
}

const persistLanguage = (language) => {
  const normalized = normalizeLang(language)
  if (!normalized) return
  try {
    window?.localStorage?.setItem("lang", normalized)
  } catch {
    // ignore persistence errors (e.g. privacy mode)
  }
}

// Normalize any existing persisted value before i18next reads it
persistLanguage(getInitialLanguage())

i18next.use(LanguageDetector).init({
  fallbackLng: "en",
  supportedLngs: ["en", "vi", "ja"],
  nonExplicitSupportedLngs: true,
  load: "languageOnly",
  ns: ["common", "errors"],
  defaultNS: "common",
  detection: {
    lookupLocalStorage: "lang",
    order: ["localStorage", "navigator"],
    caches: ["localStorage"],
  },
  interpolation: { escapeValue: false },
  resources: {
    en: {
      common: common_en,
      errors: errors_en,
    },
    vi: {
      common: common_vi,
      errors: errors_vi,
    },
    ja: {
      common: common_ja,
      errors: errors_ja,
    },
  },
})

// Ensure we persist normalized language codes only
i18next.on("languageChanged", (lng) => {
  const normalized = normalizeLang(lng)
  if (!normalized) return

  persistLanguage(normalized)

  // Avoid mixed-language UI by clearing existing toasts when language switches.
  // New toasts will use the updated locale.
  try {
    const { toast } = require("sonner")
    toast.dismiss()
  } catch {
    // ignore
  }

})

export default i18next
